import { AttachmentWithUploadStatus } from 'types/AttachmentWithUploadStatus'
import { MessageResourceType } from 'types/MessageResourceType'
import { cn } from 'utils/cn'

import type { FC, ReactNode } from 'react'

type Props = {
  icon: ReactNode
  isDetailedView?: boolean
  resourceType: MessageResourceType
  status?: AttachmentWithUploadStatus['status']
}

export const MessageResourceTagIcon: FC<Props> = ({ icon, isDetailedView = false, resourceType, status }) => (
  <div
    className={cn(
      'flex shrink-0 items-center justify-center rounded-md',
      {
        'bg-subdued': resourceType === 'attachment',
        'bg-karnovnote': resourceType === 'document_reference',
        'bg-dark': status === 'uploading' || status === 'deleting',
        'text-danger bg-transparent': status === 'error',
        'size-10': isDetailedView,
        'size-7 mr-2': !isDetailedView,
      },
    )}
  >
    {icon}
  </div>
)
